// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wrapper {
  text-align: center;
  padding: 20px;
  align-items: center;
}
.wrapper .go-back {
  text-align: right;
  width: 100%;
}
.wrapper .content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: column;
}
.wrapper ion-img {
  width: 180px;
  height: 180px;
}
.wrapper h3 {
  padding: 20px;
  color: var(--ion-color-secondary);
}
.wrapper .input-block {
  width: 100%;
}
.wrapper .input-block ion-input {
  border: 1px solid rgb(216, 216, 216);
  --border:1px solid rgb(213, 213, 213);
  width: 100%;
  transition: all ease-in-out 1s;
  border-radius: 20px;
  margin-right: 10px;
  padding: 20px;
  --padding-end: 10px;
  --padding-start: 20px;
  --highlight-color-focused: transparent;
  --border-color: transparent;
  --box-shadow: none;
  cursor: text;
}
.wrapper .input-block ion-input.error {
  border: 1px solid red;
}
.wrapper ion-button {
  margin-top: 20px;
  width: 100%;
}

.error-message span {
  color: red;
  font-size: 12px;
  padding-left: 5px;
}`, "",{"version":3,"sources":["webpack://./src/app/components/enter-personal-promo-code/enter-personal-promo-code.component.scss"],"names":[],"mappings":"AAAA;EAEI,kBAAA;EACA,aAAA;EACA,mBAAA;AAAJ;AACI;EACI,iBAAA;EACA,WAAA;AACR;AACI;EACI,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,sBAAA;AACR;AACI;EACI,YAAA;EACA,aAAA;AACR;AACI;EACI,aAAA;EACA,iCAAA;AACR;AACI;EACI,WAAA;AACR;AAAQ;EACI,oCAAA;EACA,qCAAA;EACA,WAAA;EACA,8BAAA;EACA,mBAAA;EACA,kBAAA;EACA,aAAA;EAEA,mBAAA;EACA,qBAAA;EACA,sCAAA;EAEA,2BAAA;EACA,kBAAA;EACA,YAAA;AAAZ;AAEY;EACI,qBAAA;AAAhB;AAKI;EACI,gBAAA;EACA,WAAA;AAHR;;AAOI;EACI,UAAA;EACA,eAAA;EACA,iBAAA;AAJR","sourcesContent":[".wrapper {\n\n    text-align: center;\n    padding: 20px;\n    align-items: center;\n    .go-back {\n        text-align: right;\n        width: 100%;\n    }\n    .content {\n        display: flex;\n        align-items: center;\n        justify-content: space-between;\n        flex-direction: column;\n    }\n    ion-img {\n        width: 180px;\n        height: 180px;\n    }\n    h3 {\n        padding: 20px;\n        color: var(--ion-color-secondary);\n    }\n    .input-block {\n        width: 100%;\n        ion-input {\n            border:1px solid rgb(216, 216, 216);\n            --border:1px solid rgb(213, 213, 213);\n            width: 100%;\n            transition: all ease-in-out 1s;\n            border-radius: 20px;\n            margin-right: 10px;\n            padding: 20px;\n            // --padding-top: 10px;\n            --padding-end: 10px;\n            --padding-start: 20px;\n            --highlight-color-focused: transparent;\n            // --highlight-color: transparent;\n            --border-color: transparent;\n            --box-shadow: none;\n            cursor: text;\n    \n            &.error {\n                border: 1px solid red;\n            }\n        }\n    }\n   \n    ion-button {\n        margin-top: 20px;\n        width: 100%;\n    }\n}\n.error-message {\n    span {\n        color: red;\n        font-size: 12px;\n        padding-left: 5px;\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
